import { ReactEventHandler } from "react";
import "./OverviewTab.scss";
import { getLoginAffAbo } from "../../../../../../reducers/model/boot";
import { useGetOrderListQuery } from "../../../../../../services/Customer/CustomerOrderList/customerOrderListAPI";
import { useGetCustomerListQuery } from "../../../../../../services/Customer/CustomerList/customerListAPI";
import { useAppSelector } from "../../../../../../store";
import { profileOverviewTabErrorTrack } from "../../../../../../common/tealium/CustomerProfile/Profile/ProfileTabViewsTrack/OverviewTabTrack";
import { includeGuestCustomerBN } from "../../../../../../reducers/model/customerList";
import { getCurrentPeriod } from "../../../../../../common/util/period";
import RecentOrderListView from "./RecentOrderListView/RecentOrderListView";
import IdleCustomerView from "./IdleCustomerView/IdleCustomerView";
import { ErrorTile } from "../../../../../../common/components/ErrorTile/ErrorTile";
import { storedLocale } from "../../../../../Authentication/util";

type Props = {
  viewAllOnClick: ReactEventHandler;
};

const OverviewTab = (props: Props) => {
  const { viewAllOnClick } = props;
  const locale = storedLocale();

  const profileABO = useAppSelector((state) => state.profile.affAbo);
  const customerId = Number(profileABO.split("-")[1]); // extract customer number only

  // Confidential customers (e.g. Who's New "New Customer") query orders under the sponsor ABO.
  const confidentialView = useAppSelector((state) => state.profile.confidentialView);
  // Set when the profile was opened for a customer the logged-in ABO may not own (e.g. Renewals).
  const requestWithSponsor = useAppSelector((state) => state.profile.requestWithSponsor);

  const { selectedPeriod } = useAppSelector(({ period }) => period);

  const boot = useAppSelector(({ boot }) => boot);
  const affAbo = getLoginAffAbo({ boot });
  const enableGuestCustomer = boot?.configuration?.globalCML?.enableGuestCustomer;

  const businessNature = includeGuestCustomerBN(enableGuestCustomer);

  const {
    isFetching: isFetchingIdle,
    isError: isErrorIdle,
    data: customerData,
    refetch: refetchCustomerList,
  } = useGetCustomerListQuery({
    affAbo,
    period: getCurrentPeriod(),
    pageNum: 1,
    pageSize: 1,
    sortValue: "LAST_ORDER_DATE",
    sortOrder: "DESC",
    customerIds: `${customerId}`,
    requestWithSponsor,
    ...businessNature,
  });

  if (isErrorIdle === true) {
    profileOverviewTabErrorTrack();
  }

  const { isFetching: isFetchingOrder, data: orderData } = useGetOrderListQuery({
    affAbo,
    period: selectedPeriod,
    pageNum: 1,
    pageSize: 1,
    sortValue: "ORDER_DATE",
    sortOrder: "DESC",
    customerIds: customerId,
    locale: locale,
    requestWithSponsor: confidentialView || requestWithSponsor,
    ...businessNature,
  });

  return (
    <div className="overview-tab">
      <ErrorTile
        clickFunction={refetchCustomerList}
        errorStatus={isErrorIdle}
        isLoading={isFetchingIdle}
        tealiumTrackId="overview-tab"
      />
      <div className="overview-tab__idle-customer">
        <IdleCustomerView isFetching={isFetchingIdle} customerData={customerData} profileABO={profileABO} />
      </div>
      <RecentOrderListView isFetching={isFetchingOrder} order={orderData} viewAllOnClick={viewAllOnClick} />
    </div>
  );
};

export default OverviewTab;
